import rotasDocumentos from "../../config/documentos";

function compare([a], [b]) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}

const useRoteamentoDocumentos = () => {
  const routes = Object.keys(rotasDocumentos)
    .map((rotaPrincipal) => ({
      ...rotasDocumentos[rotaPrincipal],
      rotaPrincipal,
    }))
    .reduce((rotas, { rotaPrincipal, outrasRotas, fisicalPath }) => {
      const rota = [[`/${rotaPrincipal}`, fisicalPath]].concat(
        (outrasRotas || []).map((outraRota) => [`/${outraRota}`, fisicalPath])
      );

      return [...rotas, ...rota];
    }, [])
    .sort(compare);

  return { routes };
};

export default useRoteamentoDocumentos;
